import React, { useState } from 'react';
import style from './ChangeReasonModal.module.sass';

const ChangeReasonModal = ({ onConfirm, onCancel }) => {
  const [reason, setReason] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  return (
    <div className={style.overlay}>
      <div className={style.modal}>
        <h3>Move Job</h3>
        <p>Please provide a reason for this date change:</p>
        <form onSubmit={handleSubmit}>
          <textarea
            className={style.textarea}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for the schedule change..."
            required
            autoFocus
          />
          <div className={style.buttons}>
            <button type="button" className={style.cancelButton} onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className={style.confirmButton} disabled={!reason.trim()}>
              Confirm Move
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeReasonModal;
